// The label the report headline and the history entry use for the active URL:
// the last non-empty label the search box committed. `null` (the box was
// cleared) and "" (an ATC link still waiting for its label) keep the current
// value, so clearing the box never swaps the Latin headline for the report's
// English drug_name.
export function nextTitleLabel(
  current: string | null,
  incoming: string | null,
): string | null {
  const trimmed = incoming?.trim();
  return trimmed ? trimmed : current;
}
